import React from "react"
import { graphql } from "gatsby"
import useVenuesQuery from "../../../hooks/use-venues-query"
import VenueCard from "../../cards/venue"

const VenueArchive = ({ title }) => {
  const venues = useVenuesQuery()

  return (
    <section className="venue-archive" id="locations">
      <div className="venue-archive__inner">
        <div className="venue-archive__items">
          {
            venues?.length > 0 && venues?.map((venue, i) => (
              <VenueCard key={i} {...venue} />
            ))
          }
        </div>
      </div>
    </section>
  )
}

export default VenueArchive

export const query = graphql`
  fragment VenueArchiveProps on DatoCmsVenueArchive {
    ... on DatoCmsVenueArchive {
      id
      title
    }
  }
`